export enum TourState {
  Active = 1,
  Inactive = 2
};